
      // Polyfill Buffer for Solana libraries
      import { Buffer } from "buffer";
      window.Buffer = Buffer;
    